module.exports = __webpack_public_path__ + "static/media/pha-daeng-peak.ac029cca.jpg";